<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">
        <h1 style="margin-top:25px;">Information for Home Visiting Evaluation Portal.</h1>
        <p style="font-size:24pt;">Welcome! </p>

        <p style="margin-top:10px;" class="text-danger" v-if="environment !== 'prod'" ><strong>NOTICE: THIS IS THE {{this.environment.toUpperCase()}} ENVIRONMENT. </strong></p>

        <div style="margin-top:45px; font-weight:700">
        ATTENTION: Access to this system is for authorized personnel only. Unauthorized access or use of this system is subject to civil and criminal penalties.
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    title:  'FHV IHVE Admin Portal',
    data: () => ({
      environment: null
    }),
    created(){
      this.environment = `${process.env.VUE_APP_MODE}`
    }

  }
</script>

<style>

</style>
